import { TrafficType } from '../../types/TrafficType'

export const getTrafficType = (isPro: boolean): TrafficType => {
	const isDebugMode = window.google_tag_manager?.debugGroupId
	if (isDebugMode) {
		return TrafficType.DEVELOPER
	}
	return isPro ? TrafficType.EXTERNAL : TrafficType.INTERNAL
}
